<template>
  <div>
    <div class="cui__utils__heading">
      <strong>Пользователи: Администраторы</strong>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">Администраторы</h5>
        </div>
        <div class="d-flex flex-column justify-content-center ml-3">
          <a class="btn btn-primary" @click="$router.push({ path: `/users/admins/${0}` })">Добавить</a>
        </div>
      </div>
      <div class="card-body">
        <clients-table :list="list" :paginate="pagination" @handleTableChange="handleTableChange" @removeItem="removeUser" />
      </div>
    </div>
  </div>
</template>

<script>
import ClientsTable from '@/components/users/ClientsTable'

import users from '@/mixins/users'

export default {
  name: 'admins',
  mixins: [users],
  data() {
    return {
      list: [],
      search: '',
      pagination: {
        current: 1,
        total: 1,
        pageSize: 10,
      },
      loading: false,
      types: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList(page = this.pagination.current) {
      const params = {
        page,
      }

      const users = (await this.$services.get('admin/managers', { params })).data.data.values

      this.list = users.data
      this.pagination = {
        current: users.pagination.current_page,
        total: users.pagination.total,
        pageSize: users.pagination.per_page,
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.getList()
    },
  },
  components: { ClientsTable },
}
</script>

<style scoped>

</style>
